import { dynamicSort, sortAndCreateOptions } from '../../../../common/utils/api_utils';
import { filterFieldsForImage, filterFieldsForTitleAndDescription } from '../../page/PageFormUtil';
import { getCollectionFieldTraitOptions, getCollectionFields } from '../pluginComponentApi';
export default (editor, opts) => {
  const dc = editor.DomComponents;
  const { type, label, projectId, collections } = opts;
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  const userCollection = collections.find((collection) => collection.collectionName === 'user');
  let { fields, finders } = userCollection;
  const nameFields = filterFieldsForTitleAndDescription(fields);
  const imageFields = filterFieldsForImage(fields);

  let nameFieldOptions = sortAndCreateOptions(nameFields);
  nameFieldOptions = [{ label: '-- Select Name --', value: '' }, ...nameFieldOptions];

  let imageFieldOptions = sortAndCreateOptions(imageFields);
  imageFieldOptions = [{ label: '-- Select Avatar --', value: '' }, ...imageFieldOptions];

  let finderOptions = finders.map((finder) => ({ value: finder.uuid, name: finder.name }));
  finderOptions = [{ label: '-- Select Filter --', value: '' }, ...finderOptions];

  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': label,
          projectId: projectId,
          droppable: false, // Can't drop other elements inside
          icon: '<i class="wb webconnect-chat-dots"></i>',
          collectionName: '',
          collectionFrom: '',
          finderUuid: '',
          traits: [
            {
              type: 'select',
              label: 'Name Field',
              name: 'nameField',
              changeProp: 1,
              options: nameFieldOptions,
            },
            {
              type: 'select',
              label: 'Avatar Field',
              name: 'imageField',
              changeProp: 1,
              options: imageFieldOptions,
            },
            {
              type: 'select',
              label: 'Filter',
              name: 'finderUuid',
              changeProp: 1,
              options: finderOptions,
            },
          ],
          script: function () {
            const nameField = '{[ nameField ]}';
            const imageField = '{[ imageField ]}';
            const finderUuid = '{[ finderUuid ]}';
            const projectId = '{[ projectId ]}';

            const messageOptions = { nameField, imageField, finderUuid, projectId };

            if (typeof loadChatComponent !== 'undefined') {
              loadChatComponent(this, messageOptions);
            }
          },
        },
        init() {},
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(this.model, 'change:nameField', this.updateScript);
        this.listenTo(model, 'change:imageField', this.updateScript);
        this.listenTo(model, 'change:finderUuid', this.updateScript);
      },
    }),
  });
};
